import { dataPaperClip } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaperClip = /*#__PURE__*/createIcon(dataPaperClip)
export default IconPaperClip
